import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Result.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/states";
import Btn from '../Btn';
const Result = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const { page, isMobile, weight, fullWeight, dataResults, restartHanler } = state;
  const [idResult, setIdResult] = useState(0);
  const [resultSkills, setResultSkills] = useState([]);
  const [mainResult, setMainResult] = useState(0);
  const refItems = useRef([]);
  const refPolygon = useRef(null);
  const refWrap = useRef(null);
  const refPolygonMask = useRef(null);
  useEffect(() => {
    if (page !== 2) return;
    const wrap = refWrap.current;
    const polygon = refPolygon.current;
    const polygonMask = refPolygonMask.current;
    const radius = 199; // Радиус пятиугольника
    const centerX = 200; // Центр SVG
    const centerY = 200;
    const numSides = 5; // Количество сторон (пятиугольник)


    let skills = [];
    weight.forEach((element, index) => {
      let fullW = fullWeight[index];
      skills.push(parseFloat((element * 10 / fullW).toFixed(1)));
    });

    let resultValue = 0;
    let resultIndex = 0;
    skills.forEach((element, index) => {
      if (element > resultValue) {
        resultValue = element;
        resultIndex = index;
      }
    });
    const isDoubleMax = skills.filter(element => element === resultValue).length > 1;
    if (isDoubleMax) {
      resultIndex = 5
    }
    setResultSkills(skills);
    setIdResult(resultIndex);
    setMainResult(resultValue);

    const fixSkillsForPolygon = [skills[1],skills[0],skills[4],skills[3],skills[2]];
    function drawPolygon() {
      const points = [];
      for (let i = 0; i < numSides; i++) {
        const angle = (Math.PI * 2 * i) / numSides - Math.PI / 2;
        const skillRadius = (fixSkillsForPolygon[i] / 10) * radius;
        const x = centerX + Math.cos(angle) * skillRadius;
        const y = centerY + Math.sin(angle) * skillRadius;
        points.push(`${x},${y}`);
      }
      polygon.setAttribute('points', points.join(' '));
      polygonMask.setAttribute('points', points.join(' '));
    }
    drawPolygon();

    
    document.querySelector('html').classList.add('final');
    setTimeout(() => {
      wrap.style.opacity = 1;
    }, 100);
    return()=>{
      
      wrap.style.opacity = '';
      document.querySelector('html').classList.remove('final');
    }
  }, [page, weight, fullWeight]);

  const clickHanlder = (index)=>{
    if(!isMobile) return;
    const items = refItems.current;
    items.forEach((element, i) => {
      const checkBoundaries = (e) => {
        const withinBoundaries = e.composedPath().includes(element);
        if (withinBoundaries) {
          return;
        }        
        element.classList.remove(styles.active);
        document.removeEventListener('click', checkBoundaries);
      }
      if(index === i && !element.classList.contains(styles.active)){
        element.classList.add(styles.active);
        document.addEventListener('click', checkBoundaries);
      }else{
        element.classList.remove(styles.active);        
        document.removeEventListener('click', checkBoundaries);
      }
    });
   
  }
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={styles.skills}>
          <div className={styles.skills__items}>
            {dataResults.map((element, index) => {
              if (index > 4) return null;
              return <div className={`${styles.item} ${styles[`item_${index}`]}`} key={`item-${index}`} ref={element=>refItems.current[index] = element} onClick={()=>clickHanlder(index)}>
                <div className={styles.item__number}>{`${resultSkills[index]}`.split('.').map((element, i) => {
                  if(element === 'undefined') return '';
                  if(`${resultSkills[index]}`.split('.').length === 1){
                    return <div className={styles.item__number_wrap} key={`number-${i}`}><span>{element}</span> <span>0</span></div>
                  }
                  return <span key={`number-${i}`}>{element}</span>
                })}</div>
                <div className={styles.item__desc}>{dataResults[index].desc}</div>
                <div className={styles.hint}>
                  <div className={styles.hint__icon}>
                    <img src={`${path}/img/hint-icon.svg`} alt="" />
                  </div>
                  <div className={styles.hint__body}>
                    {dataResults[index].hint}
                  </div>
                </div>
              </div>
            })}
          </div>
          <div className={styles.skills__polygon}>

            <svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="polygon-mask">
                <polygon fill="white" ref={refPolygonMask}></polygon>
              </mask>
              <polygon fill="transparent" stroke="#ffffff" strokeWidth="1" ref={refPolygon}></polygon>
              <rect width="100%" height="100%" fill="url(#skill-gradient)" mask="url(#polygon-mask)" />
              <defs>
                <radialGradient id="skill-gradient" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                  <stop offset="0%" stopColor="#66B2F2" stopOpacity="0" />
                  <stop offset="100%" stopColor="#66B2F2" stopOpacity="1" />
                </radialGradient>
              </defs>
            </svg>
          </div>
          <div className={styles.skills__bg}>
            <img src={`${path}/img/polygon-bg.svg`} alt="" />
          </div>
        </div>
        <div className={styles.info}>
          <div className={styles.info__title}>Вы — на {mainResult * 10}% {dataResults[idResult].name}</div>
          <div className={styles.info__text}>
            {dataResults[idResult].content.map((element, index) => {
              let content = [];
              element.forEach((item, i) => {
                if (item.type === 'link') {

                  content.push(<a className={styles.link} href={item.link}  target='_blank'  rel="noopener noreferrer"  key={`result-link-${index}`}><span>{item.text}</span> <img src={`${path}/img/link-icon.svg`} alt="" /></a>)
                } else {
                  content.push(item.text)
                }
              });
              return <p key={`result-text-${index}`}>{content}</p>
            })}
          </div>
          <div className={styles.info__btns}>
            <a href='https://pravo.tech/career#vacancies' target='_blank'  rel="noopener noreferrer" className={styles.info__btn}>
              <Btn>Посмотреть вакансии</Btn>
            </a>
            <a  href={`https://t.me/share/url?url=${window.location.origin + window.location.pathname}`} target='_blank'  rel="noopener noreferrer"  className={styles.info__link}>
              Поделиться проектом
              <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.3782 2.70809V0.578091C6.3782 0.0980909 6.9082 -0.159909 7.2682 0.108091L7.3302 0.162091L11.8272 4.58209C12.0372 4.78909 12.0562 5.12109 11.8842 5.35009L11.8272 5.41509L7.3302 9.83809C6.9922 10.1701 6.4432 9.95709 6.3832 9.50409L6.3782 9.42209V7.32609L6.1202 7.34909C4.3202 7.54209 2.5942 8.37309 0.933203 9.85609C0.543203 10.2041 -0.0587968 9.87609 0.00520323 9.35009C0.503203 5.26009 2.5902 3.00509 6.1532 2.72309L6.3782 2.70809Z" fill="white" />
              </svg>

            </a>
          </div>
          <div className={styles.info__restart} onClick={restartHanler}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.25 3V7.5H12.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M15.3674 11.25C14.8799 12.6299 13.9571 13.8141 12.738 14.6239C11.519 15.4337 10.0698 15.8254 8.60873 15.74C7.1477 15.6545 5.75403 15.0965 4.63773 14.15C3.52143 13.2036 2.74298 11.9199 2.41968 10.4926C2.09639 9.06518 2.24577 7.5714 2.84531 6.23631C3.44485 4.90122 4.46206 3.79716 5.74368 3.09049C7.02529 2.38382 8.50186 2.11284 9.95088 2.31837C11.3999 2.5239 12.7429 3.19481 13.7774 4.23001L17.2499 7.50001" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Пройти ещё раз
          </div>
        </div>
      </div>
    </>
  );

}

export default Result;
